import { Box, Button, Flex, Icon, Text } from "@storyofams/react-ui";
import { usePostHog } from "posthog-js/react";
import styled from "styled-components";
import { useWishlist } from "~context";
import { Heart, HeartOutline, Phone, Share } from "~components/common/Icons";

interface Footer {
  id: string;
  setIsOpen: any;
  url: string;
}
export const FooterRecipe: React.FC<Footer> = ({ id, setIsOpen, url }) => {
  const { recipesWishlist, addOrRemoveFromRecipesWishlist } = useWishlist();
  const isInWishlist: boolean = recipesWishlist && recipesWishlist.includes(id);
  const posthog = usePostHog();
  const FooterBox = styled(Box)`
    background-color: ${(p) => p.theme.colors.grey300};
    border-top: 1px solid ${(p) => p.theme.colors.grey200};
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  `;
  const buttons = [
    { text: "Stuur naar Whatsapp", icon: Phone },
    { text: "Deel op social media", icon: Share },
    { text: "Bewaar", icon: isInWishlist ? Heart : HeartOutline },
  ];
  return (
    <FooterBox padding={1} width="100%" py={"16px"} px={["18px", "32px"]}>
      <Flex flexDirection={["column", "row"]}>
        {buttons.map(({ text, icon }, i) => (
          <Box
            mb={["10px", 0]}
            py="3px"
            textAlign={["center", "left"]}
            key={text}
            border="1px solid black"
            borderRadius="6px"
            cursor="pointer"
            mr={[0, 2]}
            onClick={() => {
              // posthog.capture("Information Tab Clicks", { name: text });
              if (text === "Bewaar") {
                addOrRemoveFromRecipesWishlist(
                  isInWishlist ? "remove" : "add",
                  id
                );
                // posthog.capture("Added to wishlist recipe collection", {
                //   name: text,
                // });
              }
              if (text === "Deel op social media") {
                setIsOpen(true);
              }
            }}
          >
            {text === "Stuur naar Whatsapp" ? (
              <Button as={"a"} px="20px" href={`https://wa.me/?text=${url}`}>
                <Icon mr="10px" fontSize={"20px"} icon={icon}></Icon>
                <Text fontWeight={600} fontSize="16px" lineHeight={"32px"}>
                  {text}
                </Text>
              </Button>
            ) : (
              <Button px="20px">
                <Icon mr="10px" fontSize={"20px"} icon={icon}></Icon>
                <Text fontWeight={600} fontSize="16px" lineHeight={"32px"}>
                  {text}
                </Text>
              </Button>
            )}
          </Box>
        ))}
      </Flex>
    </FooterBox>
  );
};
